module.exports = __webpack_public_path__ + "static/img/artHealing.a13ba36.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artHealing.png
// module id = 19cT
// module chunks = 1